<template>
  <div class="sp-template">
    <div class="h-title">运力分配</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="仓库">
              <el-select v-model.lazy="queryForm.warehouseIds" filterable clearable multiple>
                <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道">
              <el-select v-model="queryForm.productIds" filterable clearable multiple placeholder="选择渠道" @change="searchTask()">
                <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input type="textarea" v-model="orderIds" placeholder="多个订单号用回车分割"></el-input>
            </el-form-item>
          </el-row>
          <el-collapse-transition>
						<div v-show="isSearchMore">
              <el-row>
                <el-form-item label="客户类型">
                  <el-select v-model.lazy="queryForm.customerType" filterable clearable multiple placeholder="选择客户类型">
                    <el-option v-for="(d, i) in customerTypeList" :key="i" :label="d.name" :value="d.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="客户">
                  <el-select v-model="queryForm.customerIds" filterable clearable multiple placeholder="选择客户">
                    <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="批次号" v-show='queryForm.status!=-1'>
                  <el-input type="textarea" v-model="batchIdText" placeholder="多个批次号用回车分割"></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="运力" v-show='queryForm.status!=-1'>
                  <el-select v-model="queryForm.capacityIds" filterable clearable multiple placeholder="选择运力">
                    <el-option v-for="(d, i) in capacityDataSelect" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="开始日期">
                  <el-date-picker v-model="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                  <el-date-picker v-model="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
                </el-form-item>
              </el-row>
            </div>
          </el-collapse-transition>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(40612)" type="primary" size="small" @click="searchTask()">搜 索</el-button>
            <el-button v-if="in_configs(40612)" size="small" @click="reset()">清 空</el-button>
            <a class="toggle-icon" @click.stop.prevent="isSearchMore = !isSearchMore">
							<b v-show="isSearchMore">隐藏</b><b v-show="!isSearchMore">展开</b>更多搜索条件
            </a>
          </div>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="queryForm.status" @tab-click="searchTask">
          <el-tab-pane v-if="in_configs(40609)" label="未处理" name="-1"></el-tab-pane>
          <el-tab-pane v-if="in_configs(40610)" label="处理中" name="0"></el-tab-pane>
          <el-tab-pane v-if="in_configs(40611)" label="完成" name="1"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
          <el-button v-show="in_configs(40601) && queryForm.status == -1" size="small" @click="chooseCapacity()">选择运力</el-button>
          <el-button v-show="in_configs(40602) && queryForm.status == -1" size="small" @click="temporaryCapacity()">临时运力分配</el-button>
           <el-dropdown style="margin-left: 10px;">
            <el-button size="small">导出信息<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-show="in_configs(40613) && queryForm.status!=1"  @click.native="downloadGoodsInfo">导出订单信息表</el-dropdown-item>
              <el-dropdown-item v-if="in_configs(40615)" @click.native="goodsInfoExport">导出货物信息</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(40616) && queryForm.status!=-1"  @click.native="downloadDeliveryOrderList">导出出货交接单</el-dropdown-item>
            </el-dropdown-menu>
           </el-dropdown>
        </div>
      </div>
      <div class="statistics">
        <span class="text">订单总数: <b class="number">{{totalOrder}}</b></span>
        <span class="text">订单总箱数: <b class="number">{{totalCarton}}</b></span>
        <span class="text">订单总体积(cbm): <b class="number">{{toFixed(totalVolume/1000000,6)==""?0:toFixed(totalVolume/1000000,6)}}</b></span>
        <span class="text">订单总重量(kg): <b class="number">{{toFixed(totalWeight,2)==""?0:toFixed(totalWeight,2)}}</b></span>
      </div>
      <!-- 未处理 -->
      <el-table v-show="queryForm.status == -1" ref="multipleTable" :data="penddingTableData" stripe border style="width: 100%" @selection-change="handleOrderSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="orderId" label="订单号"></el-table-column>
        <el-table-column label="仓库">
          <template slot-scope="scope">
            {{warehouseMap[scope.row.warehouseCode]}}
          </template>
        </el-table-column>
        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.orgOwner]}}
          </template>
        </el-table-column>
        <el-table-column label="客户类型">
          <template slot-scope="scope">
            {{customerTypeMap[scope.row.orgOwnerType]}}
          </template>
        </el-table-column>
        <el-table-column label="渠道">
          <template slot-scope="scope">
            {{channelsMaps[scope.row.procutId]}}
          </template>
        </el-table-column>
        <el-table-column label="一般贸易">
          <template slot-scope="scope">
            {{scope.row.generalTrade?"是":"否"}}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="refNumber" label="客户单号"></el-table-column> -->
        <el-table-column prop="totalCarton" label="箱数"></el-table-column>
        <el-table-column label="总体积(cbm)">
          <template slot-scope="scope">
            {{toFixed(scope.row.totalVolume/1000000,6)}}
          </template>
        </el-table-column>
        <el-table-column prop="totalWeight" label="总重量(kg)"></el-table-column>
        <el-table-column prop="volumeWeight" label="体积重"></el-table-column>
        <el-table-column prop="createAt" label="时间">
          <template slot-scope="scope">
            {{ formateDate(scope.row.createAt)}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-show="in_configs(40604) &&scope.row.totalCarton > 1" type="text" size="mini" @click="splitOrder(scope.$index, scope.row)">拆分订单</el-button>
            <el-button v-show="in_configs(40605) && !scope.row.originalOrder" type="text" size="mini" @click="delNotOriginOrder(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 处理中/已完成 -->
      <el-table class="order-operation__table" v-show="queryForm.status == 1 || queryForm.status == 0" :data="batchTableData" stripe border style="width: 100%" max-height="1000" @selection-change="handleOrderSelectionChangeEnding">
        <el-table-column type="expand">
          <template slot-scope="props">
            <table class="el-table extend-table">
              <thead>
                <tr>
                  <th>
                    <el-checkbox v-model="props.row.subChecked" @change="toggleSelectAll(props.row)"></el-checkbox>
                  </th>
                  <th>订单号</th>
                  <th>客户</th>
                  <th>客户类型</th>
                  <th>货物类型</th>
                  <th>内部关联号</th>
                  <th>一般贸易</th>
                  <th>货物箱数</th>
                  <th>总体积(cbm)</th>
                  <th>总重量(kg)</th>
                  <th>体积重</th>
                  <th>时间</th>
                  <th v-if="queryForm.status != 2">打印状态</th>
                  <th>订单操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, rowIndex) in props.row.orderValues" :key="rowIndex">
                  <td>
                    <el-checkbox v-model="row.rowSelect" @change="toggleSelectRow(props.row, row)"></el-checkbox>
                  </td>
                  <td>{{row.orderId}}</td>
                  <td>{{customerMaps[row.orgOwner]}}</td>
                  <td>{{customerTypeMap[row.orgOwnerType]}}</td>
                  <td>{{row.goodsType}}</td>
                  <td>{{row.orderExtraFields ? row.orderExtraFields.batchCode : ""}}</td>
                  <td>{{row.generalTrade?"是":"否"}}</td>
                  <td>{{row.totalCarton}}</td>
                  <td>{{toFixed(row.totalVolume/1000000,6)}}</td>
                  <td>{{row.totalWeight}}</td>
                  <td>{{row.volumeWeight}}</td>
                  <td>{{formateDate(row.createAt)}}</td>
                  <td v-if="queryForm.status != 2">{{row.execCount > 0 ?"已打印":"未打印"}}</td>
                  <td>
                    <el-button type="text" size="mini" v-show="queryForm.status == 0" @click="batchOrderDel(row, row.batchId)">删除</el-button>
                    <el-button type="text" size="mini" v-show="in_configs(40617) && queryForm.status == 1" @click="finishBatchOrderDel(row, row.batchId)">删除</el-button>
                    <el-button type="text" size="mini" @click="handleLook(row)">查看</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </el-table-column>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="batchId" label="批次号"></el-table-column>
        <el-table-column label="板/柜号">
          <template slot-scope="scope">
            <span v-if="queryForm.status == 1">{{scope.row.containerNumber}}</span>
            <el-input size="small" v-show="queryForm.status != 1" v-model.trim="scope.row.containerNumber"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="运力名称">
          <template slot-scope="scope">
            <span>{{capacityDataMaps[scope.row.capacityId]}}</span>
          </template>
        </el-table-column>
        <el-table-column label="仓库">
            <template slot-scope="scope">
                {{warehouseMap[scope.row.orderValues[0].warehouseCode]}}
            </template>
        </el-table-column>
        <el-table-column label="类型" width="150px">
            <template slot-scope="scope">
                <span v-if="!scope.row.isEdit">{{batchTypeMap[scope.row.type]}}</span>                
                <el-select v-else class="width-inline" size="small" placeholder="选择类型" v-model="scope.row.type">
                    <el-option v-for="(d,i) in batchTypeList" :key="i" :label="d.name" :value="d.id"></el-option>
                </el-select> 
                
                <el-button size="mini" type="text" v-if="!scope.row.isEdit" @click="editRow(scope.row)">编辑</el-button>
                <el-button size="mini" type="text" v-else @click="saveRow(scope.row)">保存</el-button>
                

            </template>
        </el-table-column>
        <el-table-column label="批次总订单">
          <template slot-scope="scope">
            {{batchTotalOrder(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column label="批次总箱数">
          <template slot-scope="scope">
            {{batchTotalCarton(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column label="批次总体积(cbm)">
          <template slot-scope="scope">
            {{toFixed(batchTotalVolume(scope.row)/1000000,6)}}
          </template>
        </el-table-column>
        <el-table-column label="批次总重量(kg)">
          <template slot-scope="scope">
            {{toFixed(batchTotalWeight(scope.row),2)}}
          </template>
        </el-table-column>
        <el-table-column width="100" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-dropdown trigger="click" >
							<el-button plain size="small">...</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-show="in_configs(40606) && queryForm.status ==0" size="mini" type="text" @click.native="confirmBatch(scope.row)">运力确认</el-dropdown-item>
                <el-dropdown-item  v-show="in_configs(40608) && queryForm.status == 0" size="mini" type="text" @click.native="addOrderToBatch(scope.row.batchId)">添加订单</el-dropdown-item>
                <el-dropdown-item v-show="in_configs(40607) && queryForm.status == 0" size="mini" type="text" @click.native="delBatch(scope.row.batchId)">删除批次</el-dropdown-item>
                <el-dropdown-item v-show="in_configs(40618) && queryForm.status == 1" size="mini" type="text" @click.native="delfinishBelBatch(scope.row.batchId)">删除批次</el-dropdown-item>
                <el-dropdown-item  v-show="in_configs(40603) && queryForm.status == 1" size="mini" type="text" @click.native="downLoadBatchLabel(scope.row.batchId)">打印标签</el-dropdown-item>
                <!-- <el-dropdown-item v-show="queryForm.status != 2" size="mini" type="text" @click.native="downloadPackingList(scope.row.batchId)">导出货物清单</el-dropdown-item> -->
							</el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <form action="" method="get" target="_blank" id="myform">
      </form>

      <!-- 选择运力 -->
      <el-dialog title="选择运力" :visible.sync="checkCapacityVisible" :show-close='false'>
        <div>
          使用日期:
          <el-date-picker v-model="usageDate" type="date" :picker-options="usageDateOptions" :clearable="false" value-format="yyyy-MM-dd" placeholder="使用日期" @change="getUseableCapacityData"></el-date-picker>
        </div>
        <div>当前已选货物重量{{currentTotalWeight}}kg，体积{{currentTotalVolume}} cbm</div>

        <el-table :data="capacityData" @selection-change="checkCapacityChange">
          <el-table-column label="" width="55">
            <template slot-scope="scope">
              <el-radio @change="selectCapacity()" v-model="capacityDataId" :label="scope.row.id" v-show=" (scope.row.priority=='VOLUME'&& scope.row.volumeLimit>=currentTotalVolume) || (scope.row.priority=='WEIGHT'&&scope.row.weightLimit>=currentTotalWeight)">&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column property="name" label="运力名称"></el-table-column>
          <el-table-column property="clientName" label="供应商"></el-table-column>
          <el-table-column label="渠道">
            <template slot-scope="scope">
              {{channelTypeMaps[scope.row.channelType]}}
            </template>
          </el-table-column>
          <el-table-column label="优先级">
            <template slot-scope="scope">
              {{priorityMaps[scope.row.priority]}}
            </template>
          </el-table-column>
          <el-table-column property="destination" label="目的地"></el-table-column>
          <el-table-column property="volumeLimit" label="剩余体积(cbm)"></el-table-column>
          <el-table-column property="weightLimit" label="剩余重量(kg)"></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeChooseCapacity()">取 消</el-button>
          <el-button size="small" type="primary" @click="createOrderBatch()">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 临时运力分配 -->
      <el-dialog title="临时运力分配" :visible.sync="temporaryCapacityVisible" :show-close='false'>
        <div>当前已选货物重量：{{currentTotalWeight}}kg，体积：{{currentTotalVolume}} cbm</div>
        <el-form :model="temporaryCapacityForm" size="small" label-width="90px">
          <el-row>
            <el-col :span="10">
              <el-form-item label=" 使用日期">
                <el-date-picker v-model="usageDate" type="date" :picker-options="usageDateOptions" :clearable="false" value-format="yyyy-MM-dd" placeholder="使用日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="供应商">
                <el-select v-model="temporaryCapacityForm.supplierId">
                  <el-option v-for="item in allOrgSupplers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="优先级" prop="priority">
                <el-select v-model.lazy="temporaryCapacityForm.priority">
                  <el-option v-for="item in priority" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="重量">
                <el-input type="number" min="0" v-model="temporaryCapacityForm.weight" auto-complete="off">
                  <template slot="append">kg</template>
                </el-input>
              </el-form-item>
              <el-form-item label="目的机场" v-if="isAirport" prop="destination">
                <el-input v-model="temporaryCapacityForm.destination" auto-complete="off" placeholder="目的机场"></el-input>
              </el-form-item>
              <el-form-item label="目的港" v-if="isHarbor" prop="destination">
                <el-input v-model="temporaryCapacityForm.destination" auto-complete="off" placeholder="目的港"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="渠道类型">
                <el-select v-model="temporaryCapacityForm.channelType" @change="getChannel">
                  <el-option v-for="item in channelTypes" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择渠道">
                <el-select v-model="temporaryCapacityForm.channelId" filterable>
                  <el-option v-for="item in channel" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货物类型">
                <el-select v-model="temporaryCapacityForm.goodsType">
                  <el-option v-for="(d, i) in goodsTypes" :key="i" :label="d.name" :value="d.code"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="体积">
                <el-input type="number" min="0" v-model="temporaryCapacityForm.volume" auto-complete="off">
                  <template slot="append">cbm</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="temporaryCapacityVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="createTemporaryCapacity">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 订单拆分 -->
      <el-dialog title="订单拆分" :visible.sync="splitTableVisible" :show-close='false'>
        <el-form :model="rowData" size="small" inline>
          <el-form-item label="客户" :label-width="formLabelWidth">{{customerMaps[rowData.orgOwner]}}</el-form-item>
          <el-form-item label="产品" :label-width="formLabelWidth">{{rowData.productId}}</el-form-item>
          <el-form-item label="订单号" :label-width="formLabelWidth">{{rowData.orderId}}</el-form-item>
          <el-form-item label="货物类型" :label-width="formLabelWidth">{{rowData.goodsType}}</el-form-item>
          <el-form-item label="货物箱数" :label-width="formLabelWidth">{{rowData.totalCarton}}</el-form-item>
        </el-form>

        <el-table :data="rowData.cartonDetails" @selection-change="handleSelectionCartonChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column property="cartonNumber" label="货箱编号"></el-table-column>
          <el-table-column label="体积(cbm)">
            <template slot-scope="scope">
              {{toFixed(scope.row.volume/1000000,6)}}
            </template>
          </el-table-column>
          <el-table-column property="weight" label="重量(kg)"></el-table-column>
          <el-table-column property="volumeWeight" label="体积重"></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelSplitOrder()">取 消</el-button>
          <el-button size="small" type="primary" @click="saveSplitOrder()">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 查看订单 -->
    <el-dialog title="查看订单" :visible.sync="lookVisible" width="900px">
      <el-form :model="rowData" size="small" inline>
        <el-form-item label="订单号" :label-width="formLabelWidth"><b>{{rowData.orderId}}</b></el-form-item>
        <el-form-item label="货物箱数" :label-width="formLabelWidth"><b>{{rowData.totalCarton}}</b></el-form-item>
        <el-form-item label="总重量(kg)" label-width="90px"><b>{{rowData.totalWeight}}</b></el-form-item>
        <el-form-item label="总体积(cbm)" label-width="120px"><b>{{toFixed(rowData.totalVolume/1000000,6)}}</b></el-form-item>
      </el-form>
      <el-table :data="rowData.cartonDetails">
        <el-table-column property="cartonNumber" label="货箱编号"></el-table-column>
        <el-table-column property="volume" label="体积(cbm)">
          <template slot-scope="scope">
            {{toFixed(scope.row.volume/1000000,6)}}
          </template>
        </el-table-column>
        <el-table-column property="weight" label="重量(kg)"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 批次中添加订单 -->
    <el-dialog title="添加订单" :visible.sync="addOrderTobatchDialog" width="1200px">
      <el-form :model="batchUsableTransportCapacityValue" size="small" inline>
        <el-form-item label="运力名称:" label-width="75px"><b>{{batchUsableTransportCapacityValue.name}}</b></el-form-item>
        <el-form-item label="渠道:" label-width="60px"><b>{{channelTypeMaps[batchUsableTransportCapacityValue.channelType]}}</b></el-form-item>
        <el-form-item label="剩余重量(Kg):" label-width="110px"><b>{{batchUsableTransportCapacityValue.weightLimit}}</b></el-form-item>
        <el-form-item label="剩余体积(cbm):" label-width="110px"><b>{{batchUsableTransportCapacityValue.volumeLimit}}</b></el-form-item>
      </el-form>
      <div class="selected-cartons">
        <div>当前已选货物重量：<b>{{currentTotalWeight}}</b>&nbsp;kg，</div>
        <div>体积：<b>{{currentTotalVolume}}</b>&nbsp;cbm</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelAddOrderToBatch()">取 消</el-button>
        <el-button size="small" type="primary" @click="saveAddOrderToBatch()">确 定</el-button>
      </div>
      <el-form :inline="true" :model="addOrderQueryForm" class="add-order__form" size="small">
        <el-form-item label="选择渠道">
          <el-select v-model="addOrderQueryForm.productIds" filterable clearable multiple placeholder="选择渠道" style="width: 300px;">
            <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input type="textarea" v-model="addOrderQueryOrderIds" placeholder="多个订单号用回车分割" style="width: 300px;"></el-input>
        </el-form-item>
        <el-button type="primary" style="margin-left: 30px;" size="small" @click="queryAddBatchOrderTask()">搜索</el-button>
      </el-form>
      <el-table ref="multipleTable" :data="penddingTableData" stripe border style="width: 100%" @selection-change="handleOrderSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="orderId" label="订单号"></el-table-column>
        <el-table-column label="仓库">
            <template slot-scope="scope">
                {{warehouseMap[scope.row.warehouseCode]}}
            </template>
        </el-table-column>
        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.orgOwner]}}
          </template>
        </el-table-column>
        <el-table-column label="客户类型">
          <template slot-scope="scope">
            {{customerTypeMap[scope.row.orgOwnerType]}}
          </template>
        </el-table-column>
        <el-table-column label="渠道">
          <template slot-scope="scope">
            {{channelsMaps[scope.row.procutId]}}
          </template>
        </el-table-column>
        <el-table-column label="一般贸易">
          <template slot-scope="scope">
            {{scope.row.generalTrade?"是":"否"}}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="refNumber" label="客户单号"></el-table-column> -->
        <el-table-column prop="totalCarton" label="箱数"></el-table-column>
        <el-table-column prop="totalVolume" label="总体积(cbm)">
          <template slot-scope="scope">
            {{toFixed(scope.row.totalVolume/1000000,6)}}
          </template>
        </el-table-column>
        <el-table-column prop="totalWeight" label="总重量(kg)"></el-table-column>
        <el-table-column prop="volumeWeight" label="体积重"></el-table-column>
        <el-table-column prop="createAt" label="时间">
          <template slot-scope="scope">
            {{ formateDate(scope.row.createAt)}}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleBatchSizeChange" @current-change="handleBatchCurrentChange" :current-page="batchCurrentPage" :page-sizes="batchPageSizes" :page-size="batchPageSize" layout="total, sizes, prev, pager, next, jumper" :total="batchTotal">
      </el-pagination>
    </el-dialog>

  </div>
</template>

<script>
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'

export default {
  data() {
    return {
      batchOrderIdsObj: {},
      usageDateOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 3600 * 1000 * 24;
        }
      },
      channelTypes: [
        { value: "SEA_SHIPPING", label: "海运" },
        { value: "AIR_SHIPPING", label: "空运" },
        { value: "RAILWAY_SHIPPING", label: "铁运" }
      ],
      customerTypeList: [
        // { name: "普通客户", value: "NORMAL" },
        // { name: "线上自营", value: "ONLINE_SELF_EMPLOYED" },
        // { name: "线下自营", value: "OFFLINE_SELF_EMPLOYED" },
        // { name: "线上代理", value: "ONLINE_AGENCY" },
        // { name: "线下代理", value: "OFFLINE_AGENCY" }
      ],
      customerTypeMap: {
        // NORMAL: "普通客户",
        // ONLINE_SELF_EMPLOYED: "线上自营",
        // OFFLINE_SELF_EMPLOYED: "线下自营",
        // ONLINE_AGENCY: "线上代理",
        // OFFLINE_AGENCY: "线下代理"
      },
      channel: [],
      batchTypeList: [
        {
          id: "selfsupport",
          name: "自营"
        },
        {
          id: "agency",
          name: "代理"
        }
      ],
      batchTypeMap: {
        selfsupport: "自营",
        agency: "代理"
      },
      priority: [
        {
          label: "体积优先",
          value: "VOLUME"
        },
        {
          label: "重量优先",
          value: "WEIGHT"
        }
      ],
      channelTypeMaps: {
        SEA_SHIPPING: "海运",
        AIR_SHIPPING: "空运",
        RAILWAY_SHIPPING: "铁运"
      },
      priorityMaps: {
        VOLUME: "体积",
        WEIGHT: "重量",
        VOLUME_WEIGHT: "体积重"
      },
      batchIdText: "",
      orderIds: "",
      queryForm: {
        warehouseIds: [],
        customerType: [],
        orderIds: [],
        status: "-1",
        customerIds: [],
        capacityIds: [],
        productIds: [],
        batchIds: [],
        startDate: "",
        endDate: "",
        export: 0
      },
      addOrderQueryForm: {
        productIds: [],
        orderIds: []
      },
      penddingTableData: [],
      rowData: {
        cartonDetails: [
          {
            cartonNumber: "",
            length: 0,
            width: 0,
            height: 0,
            volume: 0,
            weight: 0,
            volumeWeight: 0
          }
        ]
      },
      goodsTypes: [],
      splitCartonData: [],
      usageDate: "",
      capacityData: [],
      capacityDataId: "",
      capcaityOrderSelection: [],
      capcaityOrderSelectionEnding: [],
      selectOrderChannelIds: [],
      currentTotalWeight: 0.0,
      currentTotalVolume: 0.0,
      batchTableData: [],
      customers: [],
      customerMaps: {},
      capacityDataSelect: [],
      capacityDataMaps: {},
      channels: [],
      channelsMaps: {},
      allOrgSupplers: [],
      allOrgSupplersMaps: {},
      warehouses: [],
      warehouseMap: {},
      temporaryCapacityForm: {
        channelType: "",
        channelId: "",
        priority: ""
      },
      formLabelWidth: "100px",
      multiplecheckCapacity: [],
      totalOrder: 0,
      totalCarton: 0,
      totalWeight: 0,
      totalVolume: 0,
      totalOrder1: 0,
      totalCarton1: 0,
      totalWeight1: 0,
      totalVolume1: 0,
      isSearchMore: false,
      splitTableVisible: false,
      checkCapacityVisible: false,
      temporaryCapacityVisible: false,
      lookVisible: false,
      addOrderTobatchDialog: false,
      isAirport: false,
      isHarbor: false,
      orderTobatchId: "",
      batchUsableTransportCapacityValue: {},
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      pageSize: 10,
      total: 0,
      currentPage: 1, //当前页

      //批次添加订单查询
      addOrderQueryOrderIds: "",
      temporaryCapacityForm: {
        channelId: "",
        channelType: "",
        priority: ""
      },
      //批次添加订单分页
      batchPageSizes: [10, 20, 50, 100],
      batchPageSize: 10,
      batchTotal: 0,
      batchCurrentPage: 1 //当前页
    };
  },
  components: {},
  created() {
    this.getCustomerType();
    this.findCapacityData();
    this.getGoodsType();
    //XXX获取供应商
    this.findAllSullpers();
    setTimeout(() => {
      this.initData();
    }, 1000);
  },
  computed: {},
  methods: {
    // 全选
    toggleSelectAll(row) {
      let batchId = row.batchId;
      if (row.subChecked) {
        // 全选
        row.orderValues.forEach(item => {
          if (item.rowSelect) {
            return;
          } else {
            if (!this.batchOrderIdsObj[batchId]) {
              this.batchOrderIdsObj[batchId] = new Array(item.orderId);
            } else {
              this.batchOrderIdsObj[batchId].push(item.orderId);
            }
            item.rowSelect = !item.rowSelect;
          }
        });
      } else {
        // 取消全选
        row.orderValues.forEach(item => {
          if (!item.rowSelect) {
            return;
          } else {
            item.rowSelect = !item.rowSelect;
            this.batchOrderIdsObj[batchId].forEach((order, index) => {
              if (item.orderId === order) {
                this.batchOrderIdsObj[batchId].splice(index, 1);
              }
            });
            if (this.batchOrderIdsObj[batchId].length === 0) {
              delete this.batchOrderIdsObj[batchId];
            }
          }
        });
      }
    },
    // 单选
    toggleSelectRow(data, row) {
      let checked = row.rowSelect,
        orderId = row.orderId,
        batchId = row.batchId;
      if (checked) {
        if (!this.batchOrderIdsObj[batchId]) {
          this.batchOrderIdsObj[batchId] = new Array(orderId);
        } else {
          this.batchOrderIdsObj[batchId].push(orderId);
        }
        let bool = [];
        data.orderValues.forEach(item => {
          bool.push(item.rowSelect);
        });
        if (!bool.includes(false)) {
          data.subChecked = true;
        }
      } else {
        data.subChecked = false;
        this.batchOrderIdsObj[batchId].forEach((item, index) => {
          if (item === orderId) {
            this.batchOrderIdsObj[batchId].splice(index, 1);
          }
        });
        if (this.batchOrderIdsObj[batchId].length === 0) {
          delete this.batchOrderIdsObj[batchId];
        }
      }
    },
    // 获取客户类型
    getCustomerType() {
      this.$request1
        .get(
          '/customer/queryCustomerType'
        )
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.customerTypeList = res.data;
            this.customerTypeList.forEach(item => {
              this.customerTypeMap[item.value] = item.name;
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    rowDown(row) {
      row.rowShow = !row.rowShow;
    },
    initData() {
      let _this = this;
      let urlArray = [
        this.findAllCustomerName(),
        this.findAllWarehouse(),
        this.findAllChannle()
      ]; // unknown # of urls (1 or more)

      this.$axios.all(urlArray).then(
        this.$axios.spread(function(customerData, warehouseData, channelData) {
          _this.initCustomerData(customerData);
          _this.initWarehouseData(warehouseData);
          _this.initChannelData(channelData);
          _this.query();
        })
      );
    },
    initWarehouseData(data) {
      let _this = this;
      _this.warehouses = data.data;
      _this.warehouses.forEach(a => {
        _this.warehouseMap[a.id] = a.name;
      });
    },
    initChannelData(data) {
      let _this = this;
      _this.channels = data.data;
      if (_this.channels.length > 0) {
        _this.channels.forEach(c => {
          _this.channelsMaps[c.id] = c.name;
        });
        // _this.queryForm.productIds = _this.channels[0].id;
      }
    },
    initCustomerData(data) {
      let _this = this;
      if (data.data.success) {
        _this.customers = data.data.data;
        if (_this.customers.length > 0) {
          _this.customers.forEach(c => {
            _this.customerMaps[c.id] = c.name;
          });
        }
      }
    },
    //获取仓库
    findAllWarehouse() {
      return this.$request1.get(
        '/warehouse/staff',
        {
          withCredentials: true
        }
      );
    },
    //查询渠道
    findAllChannle() {
      return this.$request1.get(
        '/system/channel/all',
        {
          withCredentials: true
        }
      );
    },
    //查询客户
    findAllCustomerName() {
      return this.$request1.get(
        '/customerAll',
        {
          withCredentials: true
        }
      );
    },
    findAllSullpers() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/supplier',
        withCredentials: true
      })
        .then(response => {
          _this.allOrgSupplers = response.data;
          if (_this.allOrgSupplers.length > 0) {
            data.forEach((d, i) => {
              _this.allOrgSupplersMaps[d.id] = d.name;
            });
          }
        })
        .catch(error => {
          if (error.response) {
            _this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    //获取商品类型
    getGoodsType() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/order/goods-type',
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          _this.goodsTypes = data;
          data.forEach((d, i) => {
            _this.googsTypeMap[d.code] = d.name;
          });
        })
        .catch(error => {
          if (error.response) {
            _this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    //获取运力信息
    findCapacityData() {
      let _this = this;
      this.$request1
        .get(
          '/capacity',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          _this.capacityDataSelect = res.data;
          if (_this.capacityDataSelect.length > 0) {
            _this.capacityDataSelect.forEach(c => {
              _this.capacityDataMaps[c.id] = c.name;
            });
          }
        })
        .catch(function(error) {
          _this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    //获取渠道类型对应的渠道
    getChannel() {
      this.temporaryCapacityForm.channelId = "";
      this.channel = [];
      if (this.temporaryCapacityForm.channelType == "AIR_SHIPPING") {
        this.isAirport = true;
        this.isHarbor = false;
      } else {
        this.isAirport = false;
        this.isHarbor = true;
      }
      this.$request1({
        method: 'GET',
        url: '/system/channel/type',
        params: {
          channelType: this.temporaryCapacityForm.channelType
        }
      })
        .then(response => {
          this.channel = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    reset() {
      this.batchIdText = "";
      this.orderIds = "";
      this.queryForm = {
        warehouseIds: [],
        customerType: [],
        orderIds: [],
        status: "-1",
        customerIds: [],
        capacityIds: [],
        productIds: [],
        batchIds: [],
        startDate: "",
        endDate: "",
        export: 0
      };
      this.searchTask();
    },
    searchTask() {
      this.currentPage = 1;
      this.query();
    },
    query() {
      let _this = this;
      this.queryForm.orderIds = [];
      this.queryForm.batchids = [];
      if (this.orderIds !== null && this.orderIds !== "") {
        let queryOrderIds = this.orderIds.split(/[\n]+/);
        for (let item of queryOrderIds) {
          if (item.trim() != "") {
            if (this.queryForm.orderIds.indexOf(item) == -1) {
              this.queryForm.orderIds.push(item);
            }
          }
        }
      }
      if (this.queryForm.status == -1) {
        this.queryForm.capacityIds = [];
      } else {
        if (this.batchIdText !== null && this.batchIdText !== "") {
          let queryBatchIds = this.batchIdText.split(/[\n]+/);
          for (let item of queryBatchIds) {
            if (item.trim() != "") {
              if (this.queryForm.batchids.indexOf(item) == -1) {
                this.queryForm.batchids.push(item);
              }
            }
          }
        }
      }

      //过滤仓库
      let wlist = [];
      if (this.warehouses != null && this.warehouses.length > 0) {
        if (
          _this.queryForm.warehouseIds &&
          _this.queryForm.warehouseIds.length > 0
        ) {
          wlist = _this.queryForm.warehouseIds;
        } else {
          wlist = this.warehouses.map(a => a.id);
        }
      } else {
        wlist.push("NOT MATCHING");
      }

      // return;
      this.$request1({
        method: 'post',
        url: '/operation/allocation/query',
        withCredentials: true,
        data: {
          customerType: this.queryForm.customerType,
          orderIds: this.queryForm.orderIds,
          capacityIds: this.queryForm.capacityIds,
          productIds: this.queryForm.productIds,
          batchIds: this.queryForm.batchids,
          customerIds: this.queryForm.customerIds,
          status: this.queryForm.status,
          startDate: this.queryForm.startDate,
          endDate: this.queryForm.endDate,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          export: this.queryForm.export,
          warehouseIds: wlist
        }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            let taskData = data.data;
            this.total = data.total;
            this.totalOrder = 0;
            this.totalCarton = 0;
            this.totalWeight = 0;
            this.totalVolume = 0;
            if (this.total > 0) {
              if (this.queryForm.status == -1) {
                this.penddingTableData = taskData;
              } else {
                this.batchTableData = taskData;
                this.batchTableData.forEach((d, i) => {
                  this.$set(d, "rowShow", false);
                  if (d.type != null && d.type != "") {
                    _this.$set(d, "isEdit", false);
                  } else {
                    _this.$set(d, "isEdit", true);
                  }
                });
              }
              this.orderStatistics();
            } else {
              this.penddingTableData = [];
              this.batchTableData = [];
              this.total = 0;
            }
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          console.log(error);
          if (error.response) {
            this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },

    //删除待处理订单
    delNotOriginOrder(index, row) {
      this.$confirm("删除后，箱信息将合并到原订单，确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let id = row.id;
          this.$request1({
            method: 'POST',
            url: '/operation/allocation/' + id + '/del-not-origin',
            withCredentials: true
          })
            .then(response => {
              let data = response.data;
              if (data.success) {
                this.query();
              } else {
                this.$notify.error({
                  title: "错误",
                  message: data.message
                });
              }
            })
            .catch(error => {
              if (error.response) {
                this.$notify.error({
                  title: "错误",
                  message: error.response.data
                });
              }
            });
        })
        .catch(() => {
          console.log("close");
        });
    },
    //查看
    handleLook(row) {
      this.rowData = row;
      this.lookVisible = true;
    },
    //处理中删除
    batchOrderDel(row, batchId) {
      this.$confirm("确定将订单移除本批次吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let id = row.id;
          this.$request1({
            method: 'POST',
            url: '/operation/allocation/' + batchId + '/del/' + id + '',
            withCredentials: true
          })
            .then(response => {
              let data = response.data;
              if (data.success) {
                this.query();
              } else {
                this.$notify.error({
                  title: "错误",
                  message: data.message
                });
              }
            })
            .catch(error => {
              if (error.response) {
                this.$notify.error({
                  title: "错误",
                  message: error.response.data
                });
              }
            });
        })
        .catch(() => {
          console.log("close");
        });
    },
    //确认批次
    confirmBatch(row) {
      let batchId = row.batchId;
      let boardNumber = row.containerNumber;
      // if (boardNumber == null || boardNumber == "") {
      //   this.$notify.error({
      //     title: "错误",
      //     message: "板/柜号不能为空"
      //   });
      //   return;
      // }
      console.log(boardNumber);

      this.$confirm("确定运力?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1({
            method: 'POST',
            url: '/operation/allocation/' + batchId + '/confirm',
            data: {
              boardNumber: boardNumber
            },
            withCredentials: true
          })
            .then(response => {
              let data = response.data;
              if (data.success) {
                this.query();
                this.confirmBatch2(batchId)
              } else {
                this.$notify.error({
                  title: "错误",
                  message: data.message
                });
              }
            })
            .catch(error => {
              if (error.response) {
                this.$notify.error({
                  title: "错误",
                  message: error.response.data
                });
              }
            });
        })
        .catch(() => {
          console.log("close");
        });
    },
    confirmBatch2(batchId){
      this.$request1({
        method: 'get',
        // url: `${springHost}batch/confirm?batchId=` + batchId,
        url: `batch/confirm?batchId=` + batchId,
      }).then(res => {
        if(!res.data.success){
          this.$message.error(res.data.message)
        }
      })
    },
    //删除批次
    delBatch(batchId) {
      this.$confirm("确定删除批次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1({
            method: 'POST',
            url: '/operation/allocation/' + batchId + '/del',
            withCredentials: true
          })
            .then(response => {
              let data = response.data;
              if (data.success) {
                this.$notify({
                  title: "成功",
                  message: data.message,
                  type: "success"
                });
                this.query();
              } else {
                this.$notify.error({
                  title: "错误",
                  message: data.message
                });
              }
            })
            .catch(error => {
              if (error.response) {
                this.$notify.error({
                  title: "错误",
                  message: error.response.data
                });
              }
            });
        })
        .catch(() => {
          console.log("close");
        });
    },
    downLoadBatchLabel(batchId) {
      console.log(batchId);
      let url = '/operation/allocation/' + batchId + '/label/' + "100X100" + '';
      this.$windowOpen1(url);
    },
    //选择运力--------------------
    chooseCapacity() {
      //获取运力信息
      this.usageDate = new Date();
      this.capacityDataId = "";
      if (this.capcaityOrderSelection.length == 0) {
        this.$message.error("请选择订单");
        return;
      }
      this.currentTotalWeight = 0;
      this.currentTotalVolume = 0;
      this.capcaityOrderSelection.forEach((select, index) => {
        this.currentTotalWeight += select.totalWeight;
        this.currentTotalVolume += select.totalVolume;
      });
      //转换为m³
      this.currentTotalVolume = this.toFixed(
        this.currentTotalVolume / 1000000,
        6
      );
      this.currentTotalWeight = this.toFixed(this.currentTotalWeight, 3);
      this.getUseableCapacityData();
      this.checkCapacityVisible = true;
    },
    //关闭选择运力
    closeChooseCapacity() {
      this.checkCapacityVisible = false;
    },
    //获取可用的运力信息
    getUseableCapacityData() {
      let usageDate = this.formateDate(this.usageDate);
      let productId = this.selectOrderChannelIds;
      //选择订单的渠道id
      this.$request1({
        method: 'post',
        url: '/operation/allocation/usable-capacity',
        data: {
          usageDate: usageDate,
          channelIds: this.selectOrderChannelIds
        },
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.capacityData = data.data;
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          if (error.response) {
            this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    //选择运力
    selectCapacity() {
      let selectCapacityData = {};
      this.capacityData.forEach(element => {
        if (element.id == this.capacityDataId) {
          selectCapacityData = element;
          return;
        }
      });
      return selectCapacityData;
    },
    //创建批次
    createOrderBatch() {
      //判断是否满足重量或者体积
      if (this.capacityDataId == "") {
        this.$notify.error({
          title: "错误",
          message: "请选择运力"
        });
        return;
      }
      let selectCapacityData = this.selectCapacity();
      let capacityOrderIds = [];
      this.capcaityOrderSelection.forEach(element => {
        capacityOrderIds.push(element.id);
      });
      this.checkCapacityVisible = false;
      this.$request1({
        method: 'POST',
        url: '/operation/allocation',
        data: {
          capacityId: selectCapacityData.id,
          usageDate: this.usageDate,
          surplusWeight: selectCapacityData.weightLimit,
          surplusVolume: selectCapacityData.volumeLimit,
          totalWeight: this.currentTotalWeight,
          totalVolume: this.currentTotalVolume,
          capacityOrderIds: capacityOrderIds
        },
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.$notify({
              title: "成功",
              message: data.message,
              type: "success"
            });
            this.query();
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          if (error.response) {
            this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    formateDate(date) {
      return (
        new Date(date).getFullYear() +
        "-" +
        ("0" + (new Date(date).getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + new Date(date).getDate()).slice(-2) +
        " " +
        ("0" + new Date(date).getHours()).slice(-2) +
        ":" +
        ("0" + new Date(date).getMinutes()).slice(-2) +
        ":" +
        ("0" + new Date(date).getSeconds()).slice(-2)
      );
    },
    formateDateTime(date) {
      return (
        new Date(date).getFullYear() +
        "-" +
        ("0" + (new Date(date).getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + new Date(date).getDate()).slice(-2) +
        " " +
        ("0" + new Date(date).getHours()).slice(-2) +
        ":" +
        ("0" + new Date(date).getMinutes()).slice(-2) +
        ":" +
        ("0" + new Date(date).getSeconds()).slice(-2)
      );
    },
    //临时运力
    temporaryCapacity() {
      this.usageDate = new Date();
      this.capacityDataId = "";
      if (this.capcaityOrderSelection.length == 0) {
        this.$message.error("请选择订单");
        return;
      }
      this.currentTotalWeight = 0;
      this.currentTotalVolume = 0;
      this.capcaityOrderSelection.forEach((select, index) => {
        this.currentTotalWeight += select.totalWeight;
        this.currentTotalVolume += select.totalVolume;
      });
      //转换为m³
      this.currentTotalVolume = this.toFixed(
        this.currentTotalVolume / 1000000,
        6
      );
      this.currentTotalWeight = this.toFixed(this.currentTotalWeight, 3);
      this.temporaryCapacityForm = {
        channelId: ""
      };
      this.temporaryCapacityVisible = true;
    },
    //临时运力创建
    createTemporaryCapacity() {
      let form = this.temporaryCapacityForm;
      let capacityOrderIds = [];
      this.capcaityOrderSelection.forEach(element => {
        capacityOrderIds.push(element.id);
      });
      if (form.supplierId == undefined) {
        this.$message.error("请选择供应商");
        return;
      }
      if (form.channelType == undefined) {
        this.$message.error("请选择渠道类型");
        return;
      }
      if (form.channelId == undefined) {
        this.$message.error("请选择渠道");
        return;
      }
      if (form.weight == undefined || form.weight <= 0) {
        this.$message.error("请填写重量");
        return;
      }
      if (form.volume == undefined || form.volume <= 0) {
        this.$message.error("请填写体积");
        return;
      }
      if (form.priority == undefined) {
        this.$message.error("请选择临时运力优先级");
        return;
      }
      if (form.goodsType == undefined) {
        this.$message.error("请选择货物类型");
        return;
      }
      if (
        form.priority == "VOLUME" &&
        form.limitVolume < this.currentTotalVolume
      ) {
        this.$message.error("临时运力不能满足");
        return;
      }
      if (
        form.priority == "WEIGHT" &&
        this.currentTotalWeight > form.limitWeight
      ) {
        this.$message.error("临时运力不能满足");
        return;
      }
      // return;

      this.$request1({
        method: 'POST',
        url: '/operation/allocation/temporary',
        data: {
          channelType: form.channelType,

          destination: form.destination,
          channelId: form.channelId,
          supplierId: form.supplierId,
          goodsType: form.goodsType,
          priority: form.priority,
          usageDate: this.usageDate,
          totalWeight: this.currentTotalWeight,
          totalVolume: this.currentTotalVolume,
          limitWeight: form.weight,
          limitVolume: form.volume,
          capacityOrderIds: capacityOrderIds
        },
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.$notify({
              title: "成功",
              message: data.message,
              type: "success"
            });
            this.temporaryCapacityVisible = false;
            this.query();
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
          this.findCapacityData();
        })
        .catch(error => {
          if (error.response) {
            this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    //多选按钮
    checkCapacityChange(val) {
      this.multiplecheckCapacity = val;
    },

    //订单拆分---------------------
    //选择选择运力的订单
    handleOrderSelectionChange(val) {
      this.capcaityOrderSelection = val;
      this.selectOrderChannelIds = [];
      this.currentTotalWeight = 0;
      this.currentTotalVolume = 0;

      this.totalOrder = this.capcaityOrderSelection.length;
      this.totalCarton = 0;
      this.totalVolume = 0;
      this.totalWeight = 0;
      this.capcaityOrderSelection.forEach((select, index) => {
        this.currentTotalWeight += select.totalWeight;
        this.currentTotalVolume += select.totalVolume;
        if (this.selectOrderChannelIds.indexOf(select.procutId) == -1) {
          this.selectOrderChannelIds.push(select.procutId);
        }
        this.totalCarton += select.totalCarton;
        this.totalVolume += select.totalVolume;
        this.totalWeight += select.totalWeight;
      });
      //转换为m³
      this.currentTotalVolume = this.toFixed(
        this.currentTotalVolume / 1000000,
        6
      );

      if (this.capcaityOrderSelection.length == 0) {
        this.totalOrder = this.totalOrder1;
        this.totalCarton = this.totalCarton1;
        this.totalVolume = this.totalVolume1;
        this.totalWeight = this.totalWeight1;
      }
    },

    //订单拆分
    splitOrder(index, row) {
      this.rowData = row;
      this.splitTableVisible = true;
    },
    //关闭查分订单窗口
    cancelSplitOrder() {
      this.splitTableVisible = false;
      this.rowData = {};
    },
    //选择箱号拆分
    handleSelectionCartonChange(val) {
      this.splitCartonData = [];
      val.forEach((select, index) => {
        this.splitCartonData.push(select.cartonNumber);
      });
    },
    //订单拆分确定,放到对应的运力里面
    saveSplitOrder() {
      let id = this.rowData.id;
      if (this.splitCartonData.length == 0) {
        this.$notify.error({
          title: "错误",
          message: "请选择箱"
        });
        return;
      }
      this.$request1({
        method: 'POST',
        url: '/operation/allocation/split-order',
        withCredentials: true,
        data: { id: id, cartonNumbers: this.splitCartonData }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.$notify({
              title: "成功",
              message: "拆分成功",
              type: "success"
            });
            this.splitTableVisible = false;
            this.query();
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          if (error.response) {
            this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    },
    //批次添加订单分页
    handleBatchSizeChange(val) {
      this.batchPageSize = val;
      this.batchCurrentPage = 1;
      this.queryAddBatchOrder();
    },
    handleBatchCurrentChange(val) {
      this.batchCurrentPage = val;
      this.queryAddBatchOrder();
    },
    //批次里添加订单
    addOrderToBatch(batchId) {
      this.orderTobatchId = batchId;
      //获取运力信息
      this.$request1({
        method: 'GET',
        url: '/operation/allocation/' + batchId + '/capacity',
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.batchUsableTransportCapacityValue = data.data;
            this.queryAddBatchOrderTask();
            this.addOrderQueryOrderIds = "";
            this.addOrderTobatchDialog = true;
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          if (error.response) {
            this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    cancelAddOrderToBatch() {
      this.addOrderTobatchDialog = false;
    },
    //添加订单
    saveAddOrderToBatch() {
      if (this.capcaityOrderSelection.length == 0) {
        this.$message.error("请选择订单");
        return;
      }
      let capacityOrderIds = [];
      this.capcaityOrderSelection.forEach(element => {
        capacityOrderIds.push(element.id);
      });

      if (
        this.batchUsableTransportCapacityValue.priority == "WEIGHT" &&
        this.batchUsableTransportCapacityValue.weightLimit <
          this.currentTotalWeight
      ) {
        this.$message.error("选择订单的总重量不能大于运力剩余可用重量");
        return;
      }
      if (
        this.batchUsableTransportCapacityValue.priority == "VOLUME" &&
        this.batchUsableTransportCapacityValue.volumeLimit <
          this.currentTotalVolume
      ) {
        this.$message.error("选择订单的总体积不能大于运力剩余可用体积");
        return;
      }
      // return;
      this.$request1({
        method: 'POST',
        url: '/operation/allocation/batch-addorder',
        data: {
          batchId: this.orderTobatchId,
          capacityId: this.batchUsableTransportCapacityValue.id,
          usageDate: this.batchUsableTransportCapacityValue.effectiveDate,
          totalWeight: this.currentTotalWeight,
          totalVolume: this.currentTotalVolume,
          capacityOrderIds: capacityOrderIds,
          batchOperation: false
        },
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.$notify({
              title: "成功",
              message: data.message,
              type: "success"
            });
            this.addOrderTobatchDialog = false;
            this.query();
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
          this.findCapacityData();
        })
        .catch(error => {
          if (error.response) {
            this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    queryAddBatchOrderTask() {
      this.currentPage = 1;
      this.queryAddBatchOrder();
    },
    goodsInfoExport() {
      let _this = this;
      let list = [];
      if (this.queryForm.status == -1) {
        list = this.capcaityOrderSelection;
      } else if (this.queryForm.status == 0 || this.queryForm.status == 1) {
        list = this.capcaityOrderSelectionEnding;
      }
      //console.log(list);

      if (!list || list.length == 0) {
        _this.$message.error("请选择订单");
        return false;
      }
      let arrayId = [];
      if (this.queryForm.status == -1) {
        for (let i = 0; i < list.length; i++) {
          arrayId.push(list[i].orderId);
        }
      } else if (this.queryForm.status == 0 || this.queryForm.status == 1) {
        list.forEach(a => {
          a.orderValues.forEach(b => {
            arrayId.push(b.orderId);
          });
        });
      }
      //console.log(arrayId);

      // var url = tmsSpringUrl + '/order/goods-info';
      // var form = document.getElementById("myform");
      // form.setAttribute("action", url);
      // var fhtml = "";
      // fhtml +=
      //   '<input type="hidden" name="orderIds" value="' +
      //   arrayId.join(",") +
      //   '" />';

      //   fhtml +=
      //   '<input type="hidden" name="token" value="' +
      //   this.$getToken() +
      //   '" />';
      // form.innerHTML = fhtml;
      // //console.log(form);
      // form.submit();
      let formData = {
        orderIds: arrayId.join(","),
        type: ""
      }
      this.$request1({
          url: '/order/goods-info',
          method: 'post',
          data: formData
        }).then(res => {
          if(res.data.success && res.data.data!=null && res.data.data.length>0){
            
            const link = document.createElement('a')
            let array = base64ToUint8Array(res.data.data)
            let blob = new Blob([array])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
            link.setAttribute('download', `goods_info_order_${timestr}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }else{
            this.$message.error('没有数据');
          }          
        })
    },
    queryAddBatchOrder() {
      this.addOrderQueryForm.orderIds = [];
      if (
        this.addOrderQueryOrderIds !== null &&
        this.addOrderQueryOrderIds !== ""
      ) {
        let queryOrderIds = this.addOrderQueryOrderIds.split(/[\n]+/);
        for (let item of queryOrderIds) {
          if (item.trim() != "") {
            if (this.addOrderQueryForm.orderIds.indexOf(item) == -1) {
              this.addOrderQueryForm.orderIds.push(item);
            }
          }
        }
      }
      // return;
      this.$request1({
        method: 'post',
        url: '/operation/allocation/query',
        withCredentials: true,
        data: {
          status: -1,
          currentPage: this.batchCurrentPage,
          pageSize: this.batchPageSize,
          productIds: this.addOrderQueryForm.productIds,
          orderIds: this.addOrderQueryForm.orderIds
        }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            let taskData = data.data;
            this.batchTotal = data.total;
            if (this.batchTotal > 0) {
              this.penddingTableData = taskData;
            } else {
              this.penddingTableData = [];
              this.batchTotal = 0;
            }
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          console.log(error);
          if (error.response) {
            this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    handleOrderSelectionChangeEnding(val) {
      this.capcaityOrderSelectionEnding = val;
      this.totalOrder = 0;
      this.totalCarton = 0;
      this.totalVolume = 0;
      this.totalWeight = 0;
      val.forEach((item, index) => {
        this.totalOrder += this.batchTotalOrder(item);
        this.totalCarton += this.batchTotalCarton(item);
        this.totalVolume += this.batchTotalVolume(item);
        this.totalWeight += this.batchTotalWeight(item);
      });

      if (val.length == 0) {
        this.totalOrder = this.totalOrder1;
        this.totalCarton = this.totalCarton1;
        this.totalVolume = this.totalVolume1;
        this.totalWeight = this.totalWeight1;
      }
    },
    toFixed(num, len) {
      if (!num || isNaN(num)) {
        return "";
      }
      var times = Math.pow(10, len);
      var des = num * times + 0.5;
      return parseInt(des, 10) / times;
    },
    downloadGoodsInfo() {
      let _this = this;
      let ids = new Array();
      if (
        _this.queryForm.status == -1 &&
        (!this.capcaityOrderSelection ||
          this.capcaityOrderSelection.length == 0)
      ) {
        _this.$message.error("请选择订单");
        return false;
      } else {
        this.capcaityOrderSelection.forEach((d, i) => {
          ids.push(d.orderId);
        });
      }
      if (
        _this.queryForm.status == 0 &&
        (!this.capcaityOrderSelectionEnding ||
          this.capcaityOrderSelectionEnding.length == 0)
      ) {
        _this.$message.error("请选择批次");
        return false;
      } else {
        this.capcaityOrderSelectionEnding.forEach((d, i) => {
          ids.push(d.batchId);
        });
      }

      // this.$windowOpen1(
      //   '/batch-operation/download/goodsinfo' +
      //     "?ids=" +
      //     ids.toString() +
      //     "&type=" +
      //     (_this.queryForm.status == 0 ? "batch" : "order")
      // );
      this.$request1({
          url: '/batch-operation/download/goodsinfo',
          method: 'post',
          data: {
            ids: ids,
            type: (_this.queryForm.status == 0 ? "batch" : "order")
          }
        }).then(res => {
          if(res.data.success && res.data.data!=null && res.data.data.length>0){
            
            const link = document.createElement('a')
            let array = base64ToUint8Array(res.data.data)
            let blob = new Blob([array])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
            link.setAttribute('download', `订单信息表导出_${timestr}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }else{
            this.$message.error('没有数据:' + res.data.message);
          }          
        })
    },
    downloadEURAirOrder() {
      let _this = this;
      let ids = new Array();
      if (
        _this.queryForm.status == -1 &&
        (!this.capcaityOrderSelection ||
          this.capcaityOrderSelection.length == 0)
      ) {
        _this.$message.error("请选择运力");
        return false;
      } else {
        this.capcaityOrderSelection.forEach((d, i) => {
          ids.push(d.orderId);
        });
      }
      if (
        _this.queryForm.status == 0 &&
        (!this.capcaityOrderSelectionEnding ||
          this.capcaityOrderSelectionEnding.length == 0)
      ) {
        _this.$message.error("请选择运力");
        return false;
      } else {
        this.capcaityOrderSelectionEnding.forEach((d, i) => {
          ids.push(d.batchId);
        });
      }
      this.$windowOpen1(
        '/batch-operation/download/eur-air-order' +
          "?ids=" +
          ids.toString() +
          "&type=" +
          (_this.queryForm.status == 0 ? "batch" : "order")
      );
    },
    downloadDeliveryOrderList() {
      let _this = this;
      let ids = new Array();
      if (
        _this.queryForm.status != -1 &&
        (!this.capcaityOrderSelectionEnding ||
          this.capcaityOrderSelectionEnding.length == 0)
      ) {
        _this.$message.error("请选择批次");
        return false;
      } else {
        this.capcaityOrderSelectionEnding.forEach((d, i) => {
          ids.push(d.batchId);
        });
      }
      this.$windowOpen1(
        '/operation/allocation/delivery-list' +
          "?batchIds=" +
          ids.toString()
      );
    },
    batchTotalOrder(row) {
      return row.orderValues.length;
    },
    batchTotalCarton(row) {
      let totalCarton = 0;
      for (var i = 0; i < row.orderValues.length; i++) {
        totalCarton += row.orderValues[i].totalCarton;
      }
      return totalCarton;
    },
    batchTotalWeight(row) {
      let totalWeight = 0;
      for (var i = 0; i < row.orderValues.length; i++) {
        totalWeight += row.orderValues[i].totalWeight;
      }
      return totalWeight;
    },
    batchTotalVolume(row) {
      let totalVolume = 0;
      for (var i = 0; i < row.orderValues.length; i++) {
        totalVolume += row.orderValues[i].totalVolume;
      }
      return totalVolume;
    },
    orderStatistics() {
      this.$request1({
        method: 'post',
        url: '/operation/allocation/order-statistics',
        withCredentials: true,
        data: {
          customerType: this.queryForm.customerType,
          orderIds: this.queryForm.orderIds,
          capacityIds: this.queryForm.capacityIds,
          productIds: this.queryForm.productIds,
          batchIds: this.queryForm.batchids,
          customerIds: this.queryForm.customerIds,
          status: this.queryForm.status,
          startDate: this.queryForm.startDate,
          endDate: this.queryForm.endDate,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          export: this.queryForm.export
        }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.totalOrder = data.data.totalOrder;
            this.totalCarton = data.data.totalCarton;
            this.totalVolume = data.data.totalVolume;
            this.totalWeight = data.data.totalWeight;
            this.totalOrder1 = data.data.totalOrder;
            this.totalCarton1 = data.data.totalCarton;
            this.totalVolume1 = data.data.totalVolume;
            this.totalWeight1 = data.data.totalWeight;
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          if (error.response) {
            this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    finishBatchOrderDel(row, batchId) {
      this.$confirm("确定将订单移除本批次吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let id = row.id;
          this.$request1({
            method: 'post',
            url: '/operation/allocation/delete',
            params: {
              batchId: batchId,
              orderCapacityId: id,
              orderId: null
            },
            withCredentials: true
          })
            .then(response => {
              let data = response.data;
              if (data.success) {
                this.$notify({
                  title: "成功",
                  message: "删除成功",
                  type: "success"
                });
                this.query();
              } else {
                this.$notify.error({
                  title: "错误",
                  message: data.message
                });
              }
            })
            .catch(error => {
              if (error.response) {
                this.$notify.error({
                  title: "错误",
                  message: error.response.data
                });
              }
            });
        })
        .catch(() => {
          console.log("close");
        });
    },
    editRow(data) {
      let _this = this;
      data.isEdit = true;
    },
    cancelRow(data) {
      data.isEdit = false;
    },
    saveRow(data) {
      data.isEdit = false;

      var _this = this;

      var formData = {
        id: data.batchId,
        attributes: JSON.stringify({ type: data.type })
      };

      this.$request1({
        url: '/batch-operation',
        method: "post",
        data: formData,
        withCredentials: true
      })
        .then(function(res) {
          if (res.data.success) {
            _this.$message.success("提交成功");
            _this.query();
          } else {
            _this.$alert(res.data.message, "异常提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    delfinishBelBatch(batchId) {
      this.$confirm("确定删除批次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1({
            method: 'POST',
            url: '/operation/allocation/' + batchId + '/delete',
            withCredentials: true
          })
            .then(response => {
              let data = response.data;
              if (data.success) {
                this.$notify({
                  title: "成功",
                  message: "删除成功",
                  type: "success"
                });
                this.query();
              } else {
                this.$notify.error({
                  title: "错误",
                  message: data.message
                });
              }
            })
            .catch(error => {
              if (error.response) {
                this.$notify.error({
                  title: "错误",
                  message: error.response.data
                });
              }
            });
        })
        .catch(() => {
          console.log("close");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.statistics {
  // float: right;
  margin-bottom: 10px;
  font-size: 14px;
  color: #606266;
  height: 32px;
  line-height: 32px;
  .text {
    margin-right: 20px;
  }
}
.order-operation__table {
  .cell p {
    height: 44px;
  }
  .order-operation {
    position: relative;
    padding-left: 25px !important;
    .toggle-icon {
      position: absolute;
      left: 5px;
      top: 5px;
      font-size: 16px;
    }
  }
  .el-icon-circle-check-outline,
  .el-icon-plus,
  .el-icon-printer {
    cursor: pointer;
  }
  .el-icon-circle-check-outline:hover {
    color: #67c23a;
  }
  .el-icon-plus:hover,
  .el-icon-printer:hover {
    color: #409eff;
  }
}
.selected-cartons {
  display: flex;
  height: 32px;
  line-height: 32px;
  > div {
    margin-right: 15px;
  }
}
.add-order__form {
  margin-top: 20px;
}
.extend-table {
  thead tr th,
  tbody tr td {
    padding: 10px;
    &:first-child {
      border-left: 1px solid #ebeef5;
    }
  }
  thead tr th {
    border-top: 1px solid #ebeef5;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/capacityallocation.vue